require('../../shared/teamService');

angular.module('app.admin.teamInfoManager.teamInfoManagerService', [
  'app.shared.teamService'
])
  .factory('app.admin.teamInfoManager.teamInfoManagerService', [
    '$http',
    'app.shared.teamService',
    function ($http, teamService) {
      return {
        retrieve: (id) => {
          return $http.get(window.location.api('teams/' + id + '/info'));
        },
        saveContact: (team_id, contact) => {
          return $http.put(window.location.api('teams/' + team_id + '/info/contact/' + contact.id), contact);
        },
        saveAccount: (team_id, account) => {
          return $http.put(window.location.api('teams/' + team_id + '/info/account/' + account.id), account);
        },
        saveAccountCstm: (account) => {
          account = angular.copy(account);
          delete account.contacts;

          return $http.put(window.location.api('teams/' + account.fh_team_id_c + '/info/account_cstm/' + account.id_c), account);
        },
        getTeams: () => {
          return $http.get(window.location.api('teams_admin_user'));
        }
      };
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/admin/teamInfoManager/teamInfoManagerService.js